import { getFallbackValueIfNull } from 'owa-options-core';
import weatherOptions from '../data/store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
export default function isWeatherOptionDirty() {
    var optionState = weatherOptions();
    var calendarConfiguration = getCalendarConfiguration();
    /*
    * This check is mandatory since on changing between subcategories
    * isDirty() is called for corresponding subcategory to show popup to discard or save changes.
    * So if GetMailboxCalendarConfiguration api fails this functions
    * will crash as well to avoid we need this null check.
    */
    if (!calendarConfiguration) {
        return false;
    }
    var weatherEnabled = getFallbackValueIfNull(optionState.weatherEnabled, calendarConfiguration.WeatherEnabled);
    var weatherUnit = getFallbackValueIfNull(optionState.weatherUnit, calendarConfiguration.WeatherUnit);
    return (weatherEnabled !== calendarConfiguration.WeatherEnabled ||
        weatherUnit !== calendarConfiguration.WeatherUnit);
}
//# sourceMappingURL=isWeatherOptionDirty.js.map